import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import SignInService from "services/SignInService";

import { UserTypeContext } from "contexts/UserTypeContext";

import userRoleConfig from "constants/UserRoleConfig";

import {
  Input,
  Button,
  InputGroup,
  InputLeftElement,
  Box,
  Spinner,
} from "@chakra-ui/react";

import PasswordInput from "../components/PasswordInput/PasswordInput";

import signin_stock_rb_1_logo from "../assets/images/logos/signin_page/signin_stock_rb_1_logo.png";
import signin_stock_rb_2_logo from "../assets/images/logos/signin_page/signin_stock_rb_2_logo.png";

import signin_email_logo from "../assets/images/icons/signin_email_logo.svg";

import forms_ui_element from "../assets/images/ui_elements/forms_ui_element.png";
import useDocumentTitle from "hooks/useDocumentTitle";
import { isValidEmail } from "utils/ValidationUtils";
import FormErrorMessage from "components/FormErrorMessage/FormErrorMessage";
import { isNotEmpty } from "utils/ValidationUtils";

function Signin() {
  useDocumentTitle("Sign In");

  const { changeType } = useContext(UserTypeContext);

  const [signInError, setSignInError] = useState("");
  const [errorInput, setErrorInput] = useState({
    email: "",
    password: "",
  });
  const [showContactSupport, setShowContactSupport] = useState(false);

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigator = useNavigate();

  const handleForgetPasswordClick = () => {
    navigator("/forget_password");
  };

  const validateInput = (email, password) => {
    let flag = true;

    if (!isNotEmpty(email)) {
      setErrorInput((prev) => ({
        ...prev,
        email: "Please Enter an email address",
      }));

      flag = false;
    }

    if (!isNotEmpty(password)) {
      setErrorInput((prev) => ({
        ...prev,
        password: "Please Enter a password",
      }));

      flag = false;
    }

    if (!isValidEmail(email)) {
      setSignInError("Please enter a valid email address");
      setErrorInput((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
      flag = false;
    }

    return flag;
  };

  const setErrorMsg = (error, setSignInError) => {
    if (!error) {
      setSignInError("Server error");
      return;
    }

    if (!error.response) {
      setSignInError("Server error");
      return;
    }

    if (error.response.status === 404) {
      setSignInError("Invalid credentials");

      setErrorInput({
        email: "Invalid email or password",
        password: "Invalid email or password",
      });
    } else {
      setSignInError("Server error");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    setErrorInput({
      email: "",
      password: "",
    });

    setShowContactSupport(false);

    if (!validateInput(email, password)) {
      setLoading(false);
      return;
    }

    const formData = new FormData(event.target);
    try {
      const response = await SignInService(formData);

      const role = response?.data?.user_role?.Role?.user_role_name;

      setLoading(false);

      //get user role name
      const config = userRoleConfig[role];

      if (config) {
        changeType(config.changeType);
        navigator(config.navigateTo);
      } else {
        // Handle unknown user role
      }
    } catch (error) {
      setLoading(false);

      if (error.response) {
        if (error.response.status === 404) {
          setSignInError("Invalid email or password");
          setErrorInput({
            email: "Invalid email or password",
            password: "Invalid email or password",
          });
          return;
        }

        if (error.response.status === 400) {
          if (error.response.data.message) {
            if (
              error.response?.data?.message?.toLowerCase()?.includes("disabled")
            ) {
              setSignInError("Your account is inactive");
              setShowContactSupport(true);

              setErrorInput((prev) => ({
                ...prev,
                email: "Your account is inactive",
              }));

              return;
            }

            if (
              error.response?.data?.message
                ?.toLowerCase()
                ?.includes("not onboarded")
            ) {
              setSignInError(
                "Your email has not been verified. Please check your email for the verification link. "
              );
              setShowContactSupport(true);

              setErrorInput((prev) => ({
                ...prev,
                email: "Your account is inactive",
              }));

              return;
            }

            setSignInError(error?.response?.data?.message);
            return;
          } else {
            setSignInError("Server error");
          }

          return;
        }

        setSignInError("Server error");
      } else {
        setSignInError("Server error");
      }

      setErrorMsg(error, setSignInError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="sign-in-main-container">
        <div className="signin-left-panel-ts     ">
          <div className=" h-full flex flex-row justify-center  ">
            <div className="flex flex-col justify-center   ">
              <div className=" flex flex-col gap-8    ">
                <img
                  src={signin_stock_rb_1_logo}
                  className=" mx-auto w-16 h-16  "
                  alt="logo"
                />
                <img
                  src={signin_stock_rb_2_logo}
                  className=" mx-auto w-[11.7rem] h-[3.7rem] "
                  alt="logo"
                />
                <a
                  className="breadcrumb-text-active hover:cursor-pointer hover:underline"
                  onClick={() => navigator("/knowledge-base-and-support")}
                >
                  Knowledge Base and Support
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="signin-right-layout-panel z-20   ">
          <div className="    signin-right-container-tc ">
            <div className="  lg:pr-52  ">
              <div className="mb-12">
                <h1 className="pt-2 pl-2 ">Welcome back! 👋🏻</h1>
              </div>

              <form onSubmit={(e) => handleSubmit(e)}>
                {signInError && (
                  <div className="ml-2.5  w-96 mb-2 ">
                    {/* <p className="text-red-500 font-bold">
                      {signInError}
                      {showContactSupport && (
                        <>
                          {" Please contact "}
                          <a
                            className="breadcrumb-text-active hover:cursor-pointer hover:underline"
                            onClick={() =>
                              navigator("/knowledge-base-and-support")
                            }
                          >
                            Support
                          </a>
                          {" for help"}
                        </>
                      )}
                    </p> */}
                  </div>
                )}

                <div className="pb-7   w-[100%] sm:w-[25rem] xl:w-[28rem] ">
                  <p className="label">Email Address</p>
                  <InputGroup size="lg">
                    <InputLeftElement
                      sx={{ paddingTop: "15px" }}
                      pointerEvents="none"
                    >
                      <img src={signin_email_logo} />
                    </InputLeftElement>
                    <Input
                      name="email"
                      type="text"
                      placeholder="abc@email.com"
                      // width={"25rem"}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      isInvalid={errorInput?.email !== ""}
                    />
                  </InputGroup>
                  {errorInput?.email !== "" && (
                    <FormErrorMessage
                      errorMsg={errorInput?.email}
                      showContactSupport={showContactSupport}
                    />
                  )}
                </div>

                <div className="  w-[100%] sm:w-[25rem] xl:w-[28rem]">
                  <p className="label"> Password</p>
                  <PasswordInput
                    value={password}
                    onChange={setPassword}
                    isInvalid={errorInput?.password !== ""}
                  />

                  {errorInput?.password !== "" && (
                    <FormErrorMessage
                      errorMsg={errorInput?.password}
                      showContactSupport={showContactSupport}
                    />
                  )}
                </div>

                <Box className="pt-[10px]  ">
                  <Button
                    variant="ghost"
                    sx={{
                      paddingX: "10px",
                      paddingY: "16px",
                    }}
                    onClick={handleForgetPasswordClick}
                  >
                    Forgot Password?
                  </Button>
                </Box>

                <div className="mt-8 pl-2  w-[100%] sm:w-[25rem] xl:w-[28rem] ">
                  <Button
                    type="submit"
                    sx={
                      {
                        // width: "24rem",
                      }
                    }
                    isDisabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          sx={{ ml: "0.5rem" }}
                          size="lg"
                          color="white"
                        />
                      </>
                    ) : (
                      "Sign in"
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <img
        src={forms_ui_element}
        className="absolute bottom-0 right-0  h-[30vh]  z-0    "
        alt="forms_ui_element"
      />
    </>
  );
}

export default Signin;
